import axios from "axios";
import { serverConfig } from "../config";

// Create an axios instance
const axiosInstance = axios.create({
  validateStatus: false,
  baseURL: serverConfig.serverURI,
  timeout: 10000, // Optional timeout, in milliseconds
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*, application/json, text/plain",
    // Add other default headers if needed
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Do something before the request is sent
    const token = localStorage.getItem("accessToken"); // For example, get token from local storage
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`; // Add token to headers if it exists
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Helper function to handle permission update logout
const handlePermissionUpdateLogout = () => {
  // Clear all auth-related local storage
  localStorage.removeItem("accessToken");
  localStorage.removeItem("authToken");
  localStorage.removeItem("rbacPermissions");
  localStorage.removeItem("adminToken");
  localStorage.removeItem("adminPermissions");
  localStorage.removeItem("impersonatedUser");
  localStorage.removeItem("permissionsUpdatedAt");

  // Show a notification to the user
  alert("Your permissions have been updated. Please log in again to continue.");

  // Redirect to login page
  window.location.href = "/auth/sign-in";
};

// Helper function to check for PERMISSIONS_UPDATED error in GraphQL response
const hasPermissionError = (data) => {
  // Check GraphQL errors array
  if (data && data.errors && Array.isArray(data.errors)) {
    return data.errors.some(
      (err) => err.message && err.message.includes("PERMISSIONS_UPDATED")
    );
  }
  // Check legacy code format
  if (data && data.code === "PERMISSIONS_UPDATED") {
    return true;
  }
  return false;
};

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // GraphQL returns 200 even for errors, so check for permission errors here
    if (hasPermissionError(response.data)) {
      handlePermissionUpdateLogout();
      return Promise.reject(new Error("PERMISSIONS_UPDATED"));
    }
    // Any status code within the range of 2xx causes this function to trigger
    return response.data;
  },
  (error) => {
    // Check for permission error in error response
    if (error.response && error.response.data) {
      if (hasPermissionError(error.response.data)) {
        handlePermissionUpdateLogout();
        return Promise.reject(error);
      }
    }
    // Any status codes outside the range of 2xx cause this function to trigger
    if (error.response && error.response.status === 401) {
      // Handle unauthorized errors, e.g., redirect to login
      console.log("Unauthorized, logging out...");
      // Optionally, you can clear the token or redirect to a login page
    }
    console.log("Error Url:", error.config?.url);
    return Promise.reject(error);
  }
);

export { axiosInstance };
